import { render, staticRenderFns } from "./PageProfileEditView.vue?vue&type=template&id=04924f10&scoped=true&"
import script from "./PageProfileEditView.vue?vue&type=script&lang=ts&"
export * from "./PageProfileEditView.vue?vue&type=script&lang=ts&"
import style0 from "./PageProfileEditView.vue?vue&type=style&index=0&id=04924f10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04924f10",
  null
  
)

export default component.exports